/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { NotificationProps } from '@mantine/core';
import { RiCheckboxCircleFill, RiCloseCircleFill } from '@remixicon/react';

import { colorToken } from '@fai/design-tokens';
import { WarningFillIcon } from '@fai/svgr';

import { root, icon, closeButton, description, title } from './index.css';

const baseProps: NotificationProps = {
  classNames: {
    root,
    icon,
    closeButton,
    description,
    title,
  },
  withBorder: true,
};

export const errorProps: NotificationProps = {
  ...baseProps,
  icon: <RiCloseCircleFill color={colorToken.color.fg.danger.default.base} size={24} />,
};

export const successProps: NotificationProps = {
  ...baseProps,
  icon: <RiCheckboxCircleFill color={colorToken.color.fg.success.default.base} size={24} />,
};

export const warnProps: NotificationProps = {
  ...baseProps,
  icon: <WarningFillIcon size={24} />,
};
